import React from "react";
import styles from "@/styles/common/Accordion.module.scss";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";

export interface AccordionItemProps {
    title: string;
    extraTitle?: React.ReactNode;
    showDivider?: boolean;
    className?: string;
    isOpen?: boolean;
    onItemClick?: () => void;
    children: React.ReactNode;
}

const Accordion: React.FC<AccordionItemProps> = ({
    title,
    extraTitle,
    children,
    isOpen,
    onItemClick,
    showDivider = true,
    className = "",
}) => {
    const { ArrowUpSimpleLine } = userInterfaceSvg;

    const handleItemClick = () => {
        if (onItemClick) {
            onItemClick();
        }
    };

    return (
        <div className={`${styles.accordionItem} ${className}`}>
            <div
                className={`${styles.accordionItemHeader} ${
                    isOpen ? styles.accordionItemHeaderOpen : ""
                }
                ${
                    isOpen && showDivider
                        ? styles.accordionItemHeaderOpenDivider
                        : ""
                }
                `}
                onClick={handleItemClick}
            >
                <h3 className={styles.sectionTitle}>{title}</h3>
                {extraTitle && <div className="me-auto">{extraTitle}</div>}
                <div
                    className={
                        isOpen
                            ? styles.accordionItemHeaderIcon
                            : styles.accordionItemHeaderIconOpen
                    }
                >
                    <ArrowUpSimpleLine />
                </div>
            </div>
            {isOpen && (
                <div className={styles.accordionContent}>{children}</div>
            )}
        </div>
    );
};

export default Accordion;
